import enMessages from './locales/en-US';
import frMessages from './locales/fr-FR';
import { isFreedom } from "@ca.vmedia.tv/domains";
import { type IMessage } from "@/common/types/languages"

const useMessages = (): IMessage => {
    const en = enMessages as unknown as {[key: string]: string | object};
    const fr = frMessages as unknown as {[key: string]: string | object};
    const messages: IMessage = {
        en,
        fr
    }
    if (isFreedom) {
        delete messages.fr;
    }
    return messages;
};

export default defineI18nConfig(() => ({
    precompile:{
        strictMessage: false, 
        escapeHtml: true
    },
    messages: useMessages(),
    legacy: false,
    warnHtmlMessage: false,
    fallbackLocale: "en",
}))